/**
 * Based on mrgamer's idea: https://github.com/mrgamer/angular-login-example
 */
'use strict';

import angular from 'angular';
import './grandfather';
import './loginService';
import './loginControllers';
import 'angular-breadcrumb';
import {accessLevels} from './routing-config';

const loginModule = angular.module('loginModule', [
    'loginModule.grandfather',
    'loginModule.loginControllers',
    'loginModule.loginService',
    'ncy-angular-breadcrumb'
]);

loginModule.config(['$stateProvider', function ($stateProvider) {
    $stateProvider
        .state('appsoup.login', {
            url: '/login',
            templateUrl: 'views/login/login.tpl.html',
            controller: 'LoginController',
            ncyBreadcrumb: {
                label: 'HOME'
            },
            accessLevel: accessLevels.public
        })
        .state('appsoup.resetPassword', {
            url: '/reset/{token}',
            templateUrl: 'views/login/login.tpl.html',
            controller: 'LoginController',
            ncyBreadcrumb: {
                label: 'HOME'
            },
            accessLevel: accessLevels.public
        })
        .state('appsoup.error', {
            url: '/error/:error',
            templateUrl: 'views/login/error/error.tpl.html',
            ncyBreadcrumb: {
                label: 'ERROR.TITLE'
            },
            accessLevel: accessLevels.public
        });
}]);

/**
 * $rootScope.doingResolve is a flag useful to display a spinner on changing states.
 * Some states may require remote data so it will take awhile to load.
 */
loginModule.run(['stateChangeService', function (stateChangeService) {
    stateChangeService.setDoingResolve();
}]);

loginModule.service('stateChangeService', ['$rootScope', '$transitions', function ($rootScope, $transitions) {
    return {
        setDoingResolve: function () {
            // Use $transitions service for newer versions of UI-Router
            $transitions.onStart({}, function () {
                $rootScope.doingResolve = true;
            });
            $transitions.onSuccess({}, function () {
                $rootScope.doingResolve = false;
            });
            $transitions.onError({}, function () {
                $rootScope.doingResolve = false;
            });

            // Keep the old event listeners for backward compatibility
            $rootScope.$on('$stateChangeStart', function () {
                $rootScope.doingResolve = true;
            });
            $rootScope.$on('$stateChangeSuccess', function () {
                $rootScope.doingResolve = false;
            });
            $rootScope.$on('$stateChangeError', function () {
                $rootScope.doingResolve = false;
            });
            $rootScope.$on('$statePermissionError', function () {
                $rootScope.doingResolve = false;
            });
        }
    };
}]);

export default loginModule;
